document.querySelectorAll('.mx-footer, .contact-person, .contact-person-two, .mx-order-contact').forEach((section) => {
  section.addEventListener('click', (event) => {
    const clickEventPath = event.composedPath().slice(0, -2);

    for (const element of clickEventPath) {
      const clickAction = element?.getAttribute('data-click-action');
      if (!clickAction) continue;

      if (clickAction === 'open-chat-bubble') {
        openChatBubbleHandler();
        break;
      }
    }
  });
});

function openChatBubbleHandler() {
  const bubbleButton = document?.querySelector('#chat-button');

  if (!bubbleButton) return;

  GorgiasChat.open();
}
